import { getAllWidgets } from "../../../../app/api/manageWidgets";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { defaultManageWidgets, defaultManageIncludeWidgets } from "../../../../Orchestrator/Recoils/MyAccount";
import { IManageWidgetItem, IWidgetsReqAndRes } from "../../../../Orchestrator/Types/Interface/IWidgetsReqAndRes";


class FetchWidgetsAction extends BaseAction<void, void> {
    override async run(): Promise<void> {
        try {
            const response: any = await getAllWidgets();
            if (response.status === "ok" && response.answer) {
                const widgetsReqAndRes: IWidgetsReqAndRes = response.answer;

                if (Array.isArray(widgetsReqAndRes?.widgets)) {
                    const orderMap = widgetsReqAndRes.widgets.map(item => item.split(':')[0]);
                    const listOfAllWidgets = [...defaultManageWidgets, ...defaultManageIncludeWidgets]

                    // Sort order base on API widgets order
                    const orderSortWidgets = listOfAllWidgets.sort((a, b) => {
                        return orderMap.indexOf(a.valueKey) - orderMap.indexOf(b.valueKey)
                    })
                    //Update local recoil state base on API widgets value
                    const widgets = orderSortWidgets.map(({ ...widget }: IManageWidgetItem) => {
                        const findWidget = widgetsReqAndRes.widgets.find(d => d.includes(widget.valueKey))
                        if (findWidget) {
                            const widgetData = findWidget.split(":")
                            if (widgetData[1] === "true") {
                                widget.value = widgetData[1] === "true"
                                widget.itemType = "include"
                            } else {
                                widget.value = false
                                widget.itemType = ""
                            }
                        }
                        return widget
                    })
                    updateRecoilState("manageWidgetsAtom", widgets.filter(d => d.itemType !== "include"))
                    updateRecoilState("manageIncludeWidgetsAtom", widgets.filter(d => d.itemType === "include"))
                }
            }
        } catch (error: any) {
            console.error("Error fetching widgets", error);
        }
    }
}

export const fetchWidgetsAction = new FetchWidgetsAction();
